import React, { Component } from "react";
import { connect } from "react-redux";
import Avatar from "./Avatar";
import NavItems from "./NavItems";

import { withRouter } from "react-router";
import { setUser } from "../../store/actions/auth";
import { UPDATE_USER } from "../../store/actions/actionTypes";
import instance from "../../store/actions/instance";
import QRCode from "qrcode.react";

class Profile extends Component {
  state = { profileLoading: false };
  componentDidMount = async () => {
    const { settings, auth, selected_currency } = this.props;
    try {
      if (
        (settings.enable_wallet_staff && settings.enable_wallet) ||
        (settings.enable_loyalty_points_staff && settings.enable_loyalty_points)
      ) {
        this.setState({ profileLoading: true });
        const res = await instance.post("/get_user_info/", {
          country_code: selected_currency,
        });
        this.props.updateUser(res.data);
      }
    } catch (err) {}
    this.setState({ profileLoading: false });
  };
  render() {
    const { auth, language, customerContact, themeColor, settings } =
      this.props;
    const { profileLoading } = this.state;
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: language === "arabic" && "row-reverse",
            alignItems: "baseline",
            justifyContent: "space-between",
          }}
          className="mx-3"
        >
          <h2
            classname="bold"
            style={{
              fontSize: 18,
              color: "#666666",
              fontFamily: "Quicksand, Cairo",
            }}
          >
            {language === "arabic" ? "الحساب" : "Profile"}
          </h2>
          <p
            className="bold pointer mx-1"
            style={{ color: themeColor }}
            onClick={() => this.props.setUser()}
          >
            {language == "english" ? "sign out" : "تسجيل الخروج"}
          </p>
        </div>
        <div
          style={{
            display: "flex",
            gap: 25,
            flexDirection: language === "arabic" && "row-reverse",
          }}
          className="mx-4"
        >
          <Avatar src={auth.user.photo} />
          <div
            className="mt-4"
            style={{ textAlign: (language === "arabic" && "right") || "left" }}
          >
            <p className="bold mb-1" style={{ fontSize: 14, color: "#666666" }}>
              {customerContact?.name || auth.user.name}
            </p>
            <p className="mb-1" style={{ fontSize: 14, color: "#666666" }}>
              {auth.user.email}
            </p>
            {auth.user.phone && (
              <p className="mb-1" style={{ fontSize: 14, color: "#666666" }}>
                {customerContact?.phone || auth.user.phone}
              </p>
            )}

            <p
              className="bold pointer"
              style={{ color: themeColor }}
              onClick={() =>
                this.props.history.push("/checkout/details", {
                  prevPath: "profile",
                })
              }
            >
              {language == "english" ? "edit" : "تعديل"}
            </p>
          </div>
        </div>

        <div className="mt-3">
          <NavItems
            tabState={this.props.tabState}
            setTabState={this.props.setTabState}
            profileLoading={profileLoading}
          />
        </div>
        {auth?.user?.uuid && (
          <QRCode
            value={
              settings.enable_aseer_time
                ? auth?.user?.username.replace("+965", "")
                : "CustomerQR:" + auth?.user?.uuid
            }
            size={100}
            className="my-5"
            id={"QR"}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    auth: state.auth,
    customerContact: state.customers.customerContact,
    themeColor: state.store.store.settings.dark || "#0099cc",
    settings: state.store.store.settings,
    selected_currency: state.currency.selected,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (key) => dispatch(setUser(key)),
    updateUser: (user) =>
      dispatch(dispatch({ type: UPDATE_USER, payload: user })),
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Profile)
);
